<template>
  <a
    class="whatsapp-button"
    :href="whatsappUrl"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with GYMPODS on WhatsApp"
  >
    <IconWhatsApp :size="32" aria-hidden="true" />
  </a>
</template>

<script>
import IconWhatsApp from '@/components/icons/IconWhatsApp.vue';
import { WHATSAPP_URL } from '@/data/contact';

export default {
  name: 'WhatsAppButton',
  components: { IconWhatsApp },
  data() {
    return { whatsappUrl: WHATSAPP_URL };
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-button {
  position: fixed;
  bottom: 22px;
  right: 22px;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #25d366;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  text-decoration: none;
  box-shadow: 0 10px 24px -6px rgba(37, 211, 102, 0.5),
    0 4px 10px rgba(0, 0, 0, 0.18);
  z-index: 9000;
  transition: transform 0.25s ease, box-shadow 0.25s ease,
    background 0.25s ease;

  // Pulse ring. `will-change: transform, opacity` hints the compositor
  // to give this its own layer, so the infinite animation is offloaded
  // to the GPU and doesn't generate per-frame paint work on the main
  // thread (which would otherwise drag on every interaction's INP).
  &::after {
    content: '';
    position: absolute;
    inset: -6px;
    border-radius: 50%;
    border: 2px solid rgba(37, 211, 102, 0.55);
    opacity: 0;
    animation: whatsapp-pulse 2.4s ease-out infinite;
    will-change: transform, opacity;
  }

  &:hover,
  &:focus-visible {
    background: #1fb757;
    transform: translateY(-2px) scale(1.04);
    box-shadow: 0 14px 30px -6px rgba(37, 211, 102, 0.6),
      0 6px 14px rgba(0, 0, 0, 0.2);
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 3px;
  }
}

@keyframes whatsapp-pulse {
  0% {
    opacity: 0.7;
    transform: scale(1);
  }
  80% {
    opacity: 0;
    transform: scale(1.35);
  }
  100% {
    opacity: 0;
    transform: scale(1.35);
  }
}

@media (prefers-reduced-motion: reduce) {
  .whatsapp-button::after {
    animation: none;
    display: none;
  }
}

@media (max-width: 600px) {
  .whatsapp-button {
    width: 52px;
    height: 52px;
    bottom: 18px;
    right: 18px;
    font-size: 1.6rem;
  }
}
</style>
